module.exports = __webpack_public_path__ + "img/icon-29.50f91a12.svg";